// @ts-strict-ignore
import { css } from "styled-components";
import { media } from "../media-queries";

const baseSpacing = 8;
const contentMaxWidth = 171 * baseSpacing;
const contentPadding = 10 * baseSpacing;
const mobilePadding = 5 * baseSpacing;
const tabletPadding = 10 * baseSpacing;
const carouselPadding = 20 * baseSpacing;

const logoUrl = "/static/images/gemini-hor-dark-full-rgb@3x.png";
const hamburgerUrl = "/static/images/hamburger.svg";
const closeMenuUrl = "/static/images/close-menu.png";

const contentContainer = css`
  width: auto;
  max-width: auto;
  margin: 0 auto;
  padding: 0 ${mobilePadding}px;

  ${media.tablet`
    padding: 0 ${tabletPadding}px;
  `}

  ${media.desktop`
    max-width: 1365px;
  `}
`;

const fullWidthSection = css`
  margin: 0 ${-mobilePadding}px;

  ${media.desktop`
    max-width: 100%;
    margin: 0 ${-contentPadding}px;
  `}
`;

const fullWidthMobileOnly = css`
  margin: 0 ${-mobilePadding}px;
`;

const absoluteCenter = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const srOnly = css`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const layout = {
  contentContainer,
  fullWidthSection,
  fullWidthMobileOnly,
  carouselPadding,
  absoluteCenter,
  contentPadding,
  mobilePadding,
  contentMaxWidth,
  logoUrl,
  hamburgerUrl,
  closeMenuUrl,
  srOnly
};
